import React, { useEffect } from "react";
import RadioButton from "../../Fields/RadioButton";
import CheckBox from '../../Fields/CheckBox';
import { useTranslation } from "react-i18next";



const CMSearchType = (props) =>{

    const { t, i18n } = useTranslation('common');
    
    const {formJson, setFormJson} = props
    
    useEffect(()=>{
        if(formJson){
            let change = false;

            if(formJson.layout.hasSearchQuery === undefined){
                formJson.layout.hasSearchQuery = false
                change = true
            }
            if(formJson.searchInfo.qdb_seq_type === undefined){
                formJson.searchInfo.qdb_seq_type = "nucleotide";
                change = true

            }

            if(change){
                setFormJson({...formJson})
            }
        }
    },[formJson])




    const switchType = (type) =>{
        if(formJson.searchInfo.qdb_seq_type === type){
            return;
        }

        formJson.searchInfo.qdb_seq_type = type;
        if(type === "nucleotide"){
           let dbs = JSON.stringify(formJson.searchInfo.protdbs);
           
           dbs = dbs.replace(/PRT/g, "NUC");
           formJson.searchInfo.nucdbs = JSON.parse(dbs);
           formJson.searchInfo.protdbs = [];
        }

        if(type === "protein"){
            if(formJson.searchInfo.matchTu !== undefined){
                formJson.searchInfo.matchTu = false;
            }
            
            let dbs = JSON.stringify(formJson.searchInfo.nucdbs);
            dbs = dbs.replace(/NUC/g, "PRT");
            formJson.searchInfo.protdbs = JSON.parse(dbs);
            formJson.searchInfo.nucdbs = [];
        }
        setFormJson({...formJson})
    }

    return(
        <div style={{paddingBottom: "10px"}}>
            <p className="subHeading w-50 mb-10">Search Type</p>
            <div style={formJson.layout.isRedo === false ? {display: "flex", flexDirection: "column", gap: "10px"} : {display: "flex", flexDirection: "column", gap: "10px", backgroundColor: "lightGrey", padding: "10px", borderRadius: "5px", paddingBottom: "10px", marginBottom: "-10px"}}>
            
            <div style={{display: "flex", alignItems: "center"}} >
                <span style={{display: "flex", width: "240px"}}>Search Against:</span>
                <RadioButton
                    checked = {formJson.searchInfo.qdb_seq_type === "nucleotide"}
                    onChange={()=>{switchType("nucleotide")}}
                    disabled={formJson.layout.isRedo === true}
                />
                <span style={{paddingRight: "25px"}}>Nucleotide Sequences</span>
                <RadioButton
                    checked = {formJson.searchInfo.qdb_seq_type === "protein"}
                    onChange={()=>{switchType("protein")}}
                    disabled={formJson.layout.isRedo === true}
                />
                <span>Protein Sequences</span>                
            </div>
            <div  style={{display: "flex", alignItems: "center"}} >
                <span style={{display: "flex", width: "246px"}}>I have a Query Sequence</span>
                <CheckBox
                    color="primary"
                    checked={formJson.layout.hasSearchQuery == true}
                    onChange = {()=>{
                        formJson.layout.hasSearchQuery = !formJson.layout.hasSearchQuery;
                        if(!formJson.layout.hasSearchQuery){
                            delete formJson.searchInfo.qdb_seq;

                            //remove querySequence from errorIdList if present
                            const index = formJson.layout.errorIdList.indexOf("querySequence");
                            if (index > -1) {
                                formJson.layout.errorIdList.splice(index, 1);
                            }
                        }
                        setFormJson({...formJson})
                    }}
                    disabled={formJson.layout.isRedo === true}
                />
            </div>
            </div>
        </div>
    )
}

export default CMSearchType